export const column: { id: number; label: string }[] = [
  { id: 0, label: "ID" },
  { id: 1, label: "Наименование" },
  { id: 2, label: "Действия" },
];
